import React from 'react';
import { MaterialTrendButton } from '../Dashboard/MaterialTrendButton';
import { useNavigate, useParams } from 'react-router-dom';
import { useAccountStore } from '@components/Stores/accountStore';
import { useExposureStore, GENERAL_ID } from '@components/Stores/exposureDataStore';
import { useMaterialsStore } from '@components/Stores/MaterialsStore';
import { getMaterialsCardData } from '../Dashboard/dashboardUtils';
import { FinancialPositionsMaterial } from './FinancialPositionsMaterial';
import { FinancialPositionsGeneral } from './FinancialPositionsGeneral';
import { addColors, FinancialPositionSkeleton } from './components/FinancialPositionsUtils';
import { aggregateByMaterial, mapFilterPositions, positionsByMaterial } from './components/PositionsDataUtils';
import { useFinancialPositions } from '@hooks/useFinancialPositions';
import { useFinancialPositionsStore } from '@components/Stores/FinancialPositionStore';
import { useAllRoutes } from '@hooks/useRouteById';
import { useCurrencyRates } from '../../hooks/useCurrencyRates';

export const FinancialPositions: React.FC = () => {
  const navigate = useNavigate();
  const { materialId } = useParams();

  const { account, materialColorDictionary: colorsMap } = useAccountStore();
  const { materialsMap } = useMaterialsStore();
  const { pricesMap, convertionMap } = useCurrencyRates();
  const { netExposure, currentSelectedMaterialId, setCurrentSelectedMaterialId } = useExposureStore();
  const { data: allRoutes } = useAllRoutes();

  useFinancialPositions();
  const { financialPositions } = useFinancialPositionsStore();
  const [showExpired, setShowExpired] = React.useState<boolean>(false);

  React.useEffect(() => {
    setCurrentSelectedMaterialId(materialId || GENERAL_ID);
  }, [materialId]);

  const setMaterial = (materialId: string) => {
    setCurrentSelectedMaterialId(materialId);

    navigate('/financial-positions/' + (materialId && materialId !== GENERAL_ID ? materialId : ''));
  };

  return allRoutes ? (
    <div className="flex flex-col h-full gap-4">
      <MaterialTrendButton
        buttons={getMaterialsCardData(materialsMap, colorsMap, convertionMap, account.materialsToAccount, netExposure)}
        currentMaterial={currentSelectedMaterialId}
        setCurrentMaterial={setMaterial}
      />

      {materialId ? (
        <FinancialPositionsMaterial
          materialId={materialId}
          showExpired={showExpired}
          toggleExpired={() => setShowExpired((expired) => !expired)}
          positions={mapFilterPositions(
            addColors(financialPositions),
            materialId,
            allRoutes,
            materialsMap[materialId]?.currentPrice || 1,
            showExpired,
          )}
        />
      ) : (
        <FinancialPositionsGeneral
          positions={aggregateByMaterial(
            positionsByMaterial(addColors(financialPositions), false),
            materialsMap,
            colorsMap,
            pricesMap,
          )}
          setMaterial={setMaterial}
        />
      )}
    </div>
  ) : (
    <FinancialPositionSkeleton />
  );
};
